module.exports = __webpack_public_path__ + "static/media/googlegbm.695cbade.svg";